import { date, format, getValueFromJson } from "../../utils/index";
import I18n from "../../I18n";
import { datetime } from "colbi_web_ui/lib/utils";

const formatValueByType = (json, value, type, options, mask) => {
    let formatedValue = "";
    switch (type) {
        case "date":
            formatedValue = date(value, mask);
            break;
        case "currency":
            formatedValue = format(
                value,
                "normal",
                getValueFromJson(options, "currency"),
                getValueFromJson(options, "fractionDigits"),
                getValueFromJson(options, "locale"),
            );
            break;
        case "number":
            formatedValue = format(
                value,
                "normal",
                null,
                getValueFromJson(options, "fractionDigits"),
            );
            break;
        case "percentage":
            formatedValue = format(
                value,
                "normal",
                null,
                getValueFromJson(options, "fractionDigits"),
            );
            break;
        case "datetime":
            formatedValue = datetime(value, mask);
            break;
        case "object":
            const keyValue = (json[getValueFromJson(options, "id")] || {}).value;

            const objToReturn = keyValue
                ? {
                      id: (json[getValueFromJson(options, "id")] || {}).value,
                      name: (json[getValueFromJson(options, "name")] || {}).value,
                      __typename: getValueFromJson(options, "__typename"),
                  }
                : (json[getValueFromJson(options, "name")] || {}).value;

            return { type: keyValue ? type : "string", value: objToReturn };
        case "boolean":
            formatedValue = !!value === true ? I18n.translate(`Yes`) : I18n.translate(`No`);
            break;
        default:
            formatedValue = value;
            break;
    }

    return { type, value: formatedValue };
};

const mapCard = (json) => {
    const { ColumnsByLocale, FieldsData } = json;
    const parsedColumnsByLocale = JSON.parse(ColumnsByLocale || "{}");
    const parsedFieldData = JSON.parse(FieldsData || "{}");
    const resultCard = Object.keys(parsedColumnsByLocale).map((elem) => {
        const { type, basis, options, mask, align } = parsedColumnsByLocale[elem];
        return [
            {
                labels: [elem],
                ...formatValueByType(parsedFieldData, parsedFieldData[elem], type, options, mask),
                align: align ? align : "left",
                basis,
            },
        ];
    });
    resultCard.unshift([
        {
            labels: ["F60"],
            type: "string",
            align: "left",
            value: parsedFieldData["F60"],
        },
    ]);
    return resultCard;
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = (json) => {
    const headerMapping = Object.keys(json).map((elem) => {
        if (json[elem]) {
            const { name: label, align, basis } = json[elem];
            return { label: [label], align: align ? align : "left", basis };
        } else {
            return undefined;
        }
    });
    headerMapping.unshift({
        label: ["Group"],
        align: "left",
    });
    return headerMapping;
};

const factCustomtMapper = {
    map: mapper,
    header,
};

export default factCustomtMapper;
